import { get, writable } from 'svelte/store';

const STORAGE_KEY = 'shelly_dev_header_scroll_collapse';

const readInitialValue = (): boolean => {
	try {
		const stored = localStorage.getItem(STORAGE_KEY);
		// Default off until the behaviour is validated across list/dash surfaces.
		if (stored === null) return false;
		return stored === 'true';
	} catch {
		return false;
	}
};

/**
 * When true, mobile new-layout collapses the Header (home name / title / actions)
 * on downward scroll while Tabs stay sticky. Preference is saved locally.
 */
export const headerScrollCollapseEnabled = writable<boolean>(readInitialValue());

headerScrollCollapseEnabled.subscribe((value) => {
	try {
		localStorage.setItem(STORAGE_KEY, String(value));
	} catch {
		// localStorage may be unavailable
	}
});

export const isHeaderScrollCollapseEnabled = (): boolean => get(headerScrollCollapseEnabled);

export const setHeaderScrollCollapseEnabled = (enabled: boolean) => {
	headerScrollCollapseEnabled.set(enabled);
};
